import Vue from "vue";
import Router from "vue-router";

import MainView from "./views/MainView.vue";
import SupportView from "./views/SupportView.vue";
import TermsView from "./views/TermsView.vue";
import DataPrivacyView from "./views/DataPrivacyView.vue";
import AccountView from "./views/AccountView.vue";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            component: MainView,
        },
        {
            path: "/support",
            component: SupportView,
        },
        {
            path: "/terms",
            component: TermsView,
        },
        {
            path: "/dataprivacy",
            component: DataPrivacyView,
        },
        {
            path: "/account",
            component: AccountView,
        }
    ],
});
